export default () => ({
  show: false,
  close() {
    this.show = false;
  },
  toggle() {
    console.log("inventortyToggle");
    this.show = !this.show;
    Grebify.noScroll(!this.show);
  },
});
